import { CategoriaTemplate } from 'components'
import { api, graphene } from 'utils'
import { LISTING } from 'utils/endpoint'
import { NextWrapper } from '../../data-fetching-wrapper'

function Detail({ categoria, listing, pagina }) {
  return <CategoriaTemplate categoria={categoria} listing={listing} pagina={pagina} />
}

export const getServerSideProps = NextWrapper.getServerSideProps(
  async ({ params: { slug }, req }) => {
    const headers = req?.headers?.cookie ? { cookie: req.headers.cookie } : undefined

    const {
      data: {
        data: { categoria },
      },
    } = await graphene.get('', {
      params: {
        query: `
      {
        categoria(slugTree: "${slug.join('/')}") {
          pk
          titolo
          descrizione
          contentTypeId
        }
      }
    `,
      },
    })

    if (!categoria) {
      return {
        notFound: true,
      }
    }

    const {
      data: {
        data: { pagina },
      },
    } = await graphene.get('', {
      params: {
        query: `
      query {
        pagina(chiave: "categoria-detail", contentTypeId: ${categoria.contentTypeId}, objectId: ${categoria.pk}) {
          breadcrumbs {
            titolo
            url
          }
          seo {
            title
            description
            image
          }
          chiave
        }
      }
    `,
      },
    })

    const params = { categoria_id: categoria.pk }

    const response = await api.get(LISTING, { params, headers })
    const { listing } = response.data

    return {
      props: { categoria, listing, pagina, key: categoria.pk },
    }
  },
  'prodotti/[slug]'
)

export default Detail
